{
  "gunlukisler": {
    "GunlukIsler": "Daily Tasks",
    "Baslik": "Daily Tasks",
    "Yeni İş Ekle": "Add New Task",
    "İş Detayı": "Task Detail",
    "İş Bilgisi": "Task Info",
    "Tarih": "Date",
    "Saat": "Time",
    "Başlama Saati": "Start Time",
    "Bitiş Saati": "End Time",
    "Açıklama": "Description",
    "Açıklama / Not": "Description / Note",
    "Ekle": "Add",
    "Sil": "Delete",
    "Kapat": "Close",
    "Vazgeç": "Cancel",
    "Silme Onayı": "Delete Confirmation",
    "Bu kaydı silmek istediğinize emin misiniz?": "Are you sure you want to delete this record?",
    "Bugün": "Today",
    "Ay": "Month",
    "Hafta": "Week",
    "Gün": "Day",
    "Liste": "List",
    "Bilgi": "Info",
    "Data Yenile": "Check Data",
    "Güncelle": "Update",
    "Kayıt başarıyla oluşturuldu.": "Record created successfully.",
    "Kayıt başarıyla güncellendi.": "Record updated successfully.",
    "Kayıt başarıyla silindi.": "Record deleted successfully.",
    "GecmisTarihUyari": "Past dated records cannot be modified."
  }
}
